module.exports = __webpack_public_path__ + "img/16.b89a8463.png";